import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Mona_Sans%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22variable%22:%22--font-mona%22,%22axes%22:[%22wdth%22]}],%22variableName%22:%22monaFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Mona Sans', 'Mona Sans Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
